import { Box, Button, Container, useMediaQuery, useTheme } from "@mui/material";
import Masonry from "../../common/bits/masonry/masonry";
import React, { useEffect, useState } from 'react';
import Headings from "../../common/headings/headings";
import { useHistory } from "react-router-dom";
import apiGallery from "../../../core/api/gallery/api.gallery";
import { ParamGalleryItem } from "../../../models/gallery";


function Gallery(props) {
    const theme = useTheme();
    const ltxs = useMediaQuery(theme.breakpoints.down("xs"));
    const matches = useMediaQuery('(max-width:460px)');
    const ltsm = useMediaQuery(theme.breakpoints.down("sm"));
    const history = useHistory();
    const [galleryImages, setGalleryImages] = useState<ParamGalleryItem[]>();

    const navigateTo = () => {
        history.push('explore/all');
    }

    const getData = async () => {
        let data = await apiGallery.getImagesFromGallery();
        setGalleryImages(data)
    }
    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <Container maxWidth="lg">
                <div className="ui-padding--32"></div>
                <Headings heading="Beyond Work"></Headings>
                <div className="ui-padding--12"></div>
                <p className="ui-typo--body1 ui-font-weight--normal app-summary">Exploring life through travel, photography, cooking, and long rides on two wheels.</p>
                <div className="ui-padding--12"></div>
                  {galleryImages && (
                    <Masonry
                        items={galleryImages}
                        ease="power3.out"
                        duration={0.6}
                        stagger={0.05}
                        animateFrom="bottom"
                        scaleOnHover={true}
                        hoverScale={0.95}
                        blurToFocus={true}
                        colorShiftOnHover={false}
                    />
                    )}
                <Box p={8}></Box>
                <Box p={ltsm ? 24 : 18}></Box>
                <Box p={matches ?  98 : 0}></Box>
                <Box p={matches ? 24 : 0}></Box>
                {/* <div className={ltsm ? "ui-width--full ui-padding--h-56" : "ui-flex--justify-center"}>
                    <Button className={ltsm ? "ui-width--full" : ""} variant={ltsm ? "contained" : "outlined"} size="large" color={"primary"} onClick={() => navigateTo()}>
                        View All
                    </Button>
                </div> */}
               
            </Container>
        </>
    );
}

export default Gallery;
